import { render } from "./SelectItem.vue?vue&type=template&id=2ec665a5&scoped=true"
import script from "./SelectItem.vue?vue&type=script&lang=js"
export * from "./SelectItem.vue?vue&type=script&lang=js"

import "./SelectItem.vue?vue&type=style&index=0&id=2ec665a5&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec665a5"]])

export default __exports__